<template>
  <BContainer>
    <BRow>
      <BCol>
        <h1>{{ $t('ticket_claimed') }}</h1>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import {BCol, BContainer, BRow} from "bootstrap-vue-next";

export default {
  components: {
    BCol,
    BRow,
    BContainer
  },
  data() {
    return {}
  }
}
</script>
